// extracted by mini-css-extract-plugin
export default {"Subscribebox":"subscribe_Subscribebox__Mk5Wv","formWrapmain":"subscribe_formWrapmain__HdyZX","formWrap":"subscribe_formWrap__TExu6","marginbotton":"subscribe_marginbotton__Sj1Pf"};